import { cloneElement } from 'react'
import { TextField, useRecordContext } from 'react-admin'

export const DynamicField = ({ component = <TextField source='_' />, source, ...rest }: any) => {
  // react-admin 4 stopped injecting `record` as a prop, so it now comes from
  // context — and that context is undefined until the record has loaded, which
  // the template below would dereference.
  const record = useRecordContext(rest)
  if (!record) return null

  return cloneElement(component, {
    ...rest,
    record: { ...record, _: eval('`' + source + '`') },
    source: '_',
  })
}

export default DynamicField
